import config from "../../../config";
import axiosInstance from "../../../util/axiosInstance";

import { getToken } from "../../../util/Cookies";

// ✅ Fetch Catering Master Item List
export const getCateringItemMasterList = async (exclude_side_items) => {
  const token = getToken();
  console.log("exclude_side_items",exclude_side_items)
  try {
    const response = await axiosInstance.get("/catering-items/mst-list/new", {
      params: { 
      
      },
      headers: {
        Authorization: `${token}`,
      },
    });

    if (response.status === 200) {
      return response.data.data;
    } else {
      throw new Error(response.message || "Unable to fetch catering item master list");
    }
  } catch (error) {
    console.error("❌ Error fetching catering item master list:", error);
  }
};


export const getCateringCategoryList = async (selected_meal_type_id) => {
  const token = getToken();
  try {
    const response = await axiosInstance.get(selected_meal_type_id == null ? "/catering-items/catering-item-groups" : `/catering-items/catering-item-groups?mealId=${selected_meal_type_id}`, {
      params: { 
      },
      headers: {
        Authorization: `${token}`,
      },
    });

    if (response.status === 200) {
      return response.data.data;
    } else {
      throw new Error(response.message || "Unable to fetch catering item master list");
    }
  } catch (error) {
    console.error("❌ Error fetching catering item master list:", error);
  }
};

export const getCateringItem= async (exclude_side_items) => {
  const token = getToken();
  console.log("exclude_side_items",exclude_side_items)
  try {
    const response = await axiosInstance.get("/catering-items/included-items");

    if (response.status === 200) {
      return response.data.data;
    } else {
      throw new Error(response.message || "Unable to fetch catering item master list");
    }
  } catch (error) {
    console.error("❌ Error fetching catering item master list:", error);
  }
};

// // Usage - make sure you're passing the correct values
// const masterItems = await getCateringItemMasterList("false"); // Include side items
// const sidemasterItems = await getCateringItemMasterList("true"); // Exclude side items

// ✅ Fetch Unit Type Master List
export const getCateringUnitTypeList = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/master/catUnitType", {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    });
    console.log("called",response.data)
    if (response.status === 200) {
      return response.data.data;
    } else {
      throw new Error(response.message || "Unable to fetch unit types");
    }
  } catch (error) {
    console.error("❌ Error fetching unit type list:", error);
  }
};

export const fetchProviderData = async () => {
  try {
    const response = await axiosInstance.get("/provider-types", {
      method: "GET",
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error("Network response was not ok");
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getServiceProviderServices = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/services", {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    // dispatch(profileFailuer(error.message));
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getCateringProviderServices = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/cuisine/meals-type", {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getCateringProviderCuisines = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/cuisine/cuisine-types", {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to get the provider cuisines"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getCateringProviderCategories = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/cuisine/categories", {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to get the provider categories"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};
// In your fetchProviderData.js file
export const updateusepackage = async (cateringServices) => {
  const token = getToken();
  console.log("catering_Services", cateringServices);
  try {
    const response = await axiosInstance.put(
      "/catering-items/user-packages",
      { userPackages: [cateringServices] }
    );
    if (response.status === 201) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to add the catering services"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
    throw error;
  }
};

export const createusepackage = async (cateringServices) => {
  const token = getToken();
  console.log("catering_Services", cateringServices);
  try {
    const response = await axiosInstance.post(
      "/catering-items/user-packages",
      { userPackages: [cateringServices] }
    );
    if (response.status === 201) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to add the catering services"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
    throw error;
  }
};

export const getuserpackage = async () => {
  const token = getToken();
  try {
    const response = await axiosInstance.get(
      "/catering-items/user-packages"
      // GET typically doesn't have a request body, uses query params or URL
    );
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to fetch catering services"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
    throw error;
  }
};

export const deleteuserpackage = async (packageIds) => {
  const token = getToken();
  console.log(" Deleting user packages:", packageIds);
  try {
    const response = await axiosInstance.delete(
      "/catering-items/user-packages",
      {
        data: { packageIds: Array.isArray(packageIds) ? packageIds : [packageIds] }
      }
    );
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to delete catering service"
      );
    }
  } catch (error) {
    console.error("There was a problem with the delete operation:", error);
    throw error;
  }
};
export const addCateringProviderServices = async (cateringServices) => {
  const token = getToken();
  console.log("catering_Services",cateringServices)
  try {
    const response = await axiosInstance.post(
      "/catering-items",
           { cateringItems: [cateringServices] } ,
 
    );
    if (response.status === 201) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to add the catering services"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const updateCateringProviderServices = async (cateringServices) => {
  const token = getToken();
  console.log("cateringServices",cateringServices)
  try {
    const response = await axiosInstance.put(
      "/catering-items",
        { cateringItems: [cateringServices] },
      {
        method: "PUT",
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to add the catering services"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const deleteCateringProviderServices = async (cateringServiceItems) => {
  const token = getToken();

  try {
    const response = await axiosInstance.delete("/catering-items", {
      method: "DELETE",
      headers: {
        Authorization: `${token}`,
      },
      data: cateringServiceItems,
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to add the catering services"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};
  
export const getCateringProviderAddedServices = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/catering-items", {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to get already added catering services"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const addCateringProviderMenuImage = async (formData) => {
  console.log("FormData", formData);

  const token = getToken();

  try {
    const response = await axiosInstance.post("/gallery/upload", formData, {
      method: "POST",
      headers: {
        Authorization: `${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.status === 201) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to add the catering services"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getPriestProviderEvents = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/priest/mappedEvents", {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    });
    if (response.status === 200) {
      return response?.data?.data || [];
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    // dispatch(profileFailuer(error.message));
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getPriestEvents = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/master/priestEventMaster", {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    });
    if (response.status === 200) {
      return response?.data?.data || [];
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    // dispatch(profileFailuer(error.message));
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const createPriestEventspackage = async (data) => {
  

  try {
    const response = await axiosInstance.post("/priest/package",data);

    return response
  } catch (error) {
    // dispatch(profileFailuer(error.message));
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const updatePriestEventspackage = async (data) => {
  

  try {
    const response = await axiosInstance.put("/priest/package",data);

    return response
  } catch (error) {
    // dispatch(profileFailuer(error.message));
    console.error("There was a problem with the fetch operation:", error);
  }
};


export const deletePriestEventspackage = async (packageId) => {
  

  try {
    const response = await axiosInstance.delete(`/priest/package/${packageId}`);

    return response
  } catch (error) {
    // dispatch(profileFailuer(error.message));
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getPriestEventspackage = async () => {
  

  try {
    const response = await axiosInstance.get("/priest/package/list");

    return response
  } catch (error) {
    // dispatch(profileFailuer(error.message));
    console.error("There was a problem with the fetch operation:", error);
  }
};
export const getServiceProvidersByID = async (Id, Lat, Long, eventId) => {
  try {
    let url = `/provider?typeId=${Id}&latitude=${Lat}&longitude=${Long}&order=asc`;
    if (eventId != null) {
      url += `&eventTypeId=${eventId}`;
    }
    const response = await axiosInstance.get(url, {
      method: "GET",
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    // dispatch(profileFailuer(error.message));
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const gettentpackages = async(id) =>{
  try {
    const response = await axiosInstance.get(`/v1/tent-house/package/by-event/${id}`)
    return response
  } catch (error) {
    console.log("got error while getting tentpackages",error)
  }
}
export const getPriestsListByLocation = async (Lat, Long, eventId) => {
  try {
    let url = `/priest/list?eventId=${eventId}&latitude=${Lat}&longitude=${Long}&order=desc`;
    const response = await axiosInstance.get(url, {
      method: "GET",
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    // dispatch(profileFailuer(error.message));
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getTentHouseListByLocationpost = async (Lat, Long, eventId, serviceIds) => {
  try {
    const url = `/tent-house/list-by-service?eventId=${eventId}&latitude=${Lat}&longitude=${Long}&order=asc`;

    const response = await axiosInstance.post(url, {
      serviceIds: serviceIds, // e.g., [8, 9]
    });

    if (response.status === 200) {
      
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
    throw error;
  }
};
export const getTentHouseListByLocation = async (Lat, Long, eventId) => {
  try {
    let url = `/tent-house/list?eventId=${eventId}&latitude=${Lat}&longitude=${Long}&order=asc`;
    const response = await axiosInstance.get(url, {
      method: "GET",
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    // dispatch(profileFailuer(error.message));
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const catering_includeditems = async()=>{
  try {
    const response = await axiosInstance.get('/catering-items/included-items')
    console.log("response of includeditems",response)
    return response.data.data
  } catch (error) {
    console.log("couldn't get the included items",error)
  }
}
export const getCateringProvidersByEventLocation = async (latitude, longitude, eventTypeId) => {
  try {
    let url = `/caterer/list-by-services?eventTypeId=${eventTypeId}&latitude=${latitude}&longitude=${longitude}&order=asc`;
    
    const response = await axiosInstance.post(url, {
    
    });
    
    console.log("Catering providers by location:", response)
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
    throw error;
  }
};



export const getCateringListByLocation = async (Lat, Long, eventId,cateringdata) => {
  try {

    console.log("Sending payload:", JSON.stringify(cateringdata));
    let url = `/caterer/list-by-services?eventId=${eventId}&latitude=${Lat}&longitude=${Long}&order=asc`;
    const response = await axiosInstance.post(url,cateringdata, {
     headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    console.log("cateringdata",response)
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    // dispatch(profileFailuer(error.message));
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getProviderServicesByID = async (Id) => {
  try {
    const response = await axiosInstance.get(
      `/provider/services?providerId=${Id}`,
      {
        method: "GET",
      }
    );
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    // dispatch(profileFailuer(error.message));
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const fetchserviceitemssecond = async () => {
    try {
        const token = getToken();
        const response = await axiosInstance.get('/v1/tent-house/services', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        // console.log("response",response)
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error('Network response was not ok');
        }
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
    }
};

export const getimagesidforcateringcusines = async() =>{
  try {
    const response = await axiosInstance.get("/cuisine/cuisine-types/images")
    return response
  } catch (error) {
    console.log("got error on fetching images ids",error)
  }
}


export const getTentHouseProviderServices = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/tent-house/services", {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getgalleryimages = async (id, isDownload = false) => {
  const token = getToken();

  try {
    const response = await axiosInstance.get(`/gallery/download/${id}`, {
      headers: {
        Authorization: `${token}`,
      },
      params: {
        isDownload, 
      },
      responseType: "blob", 
    });

    return response.data; // This will be a Blob
  } catch (error) {
    console.error("Error fetching gallery image:", error);
    throw error;
  }
};


export const getTentHouseProviderAddedServices = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/tent-house/mappings", {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const deleteTentHouseProviderServices = async (
  tentHouseServiceItems
) => {
  const token = getToken();

  try {
    const response = await axiosInstance.delete("/tent-house/mappings", {
      method: "DELETE",
      headers: {
        Authorization: `${token}`,
      },
      data: tentHouseServiceItems,
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to add the catering services"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const updateTentHouseProviderServices = async (tentHouseServices) => {
  const token = getToken();

  try {
    const response = await axiosInstance.put(
      "/tent-house/mappings",
      tentHouseServices,
      {
        method: "PUT",
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to update the tent house services"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const addTentHouseProviderServices = async (tentHouseServices) => {
  const token = getToken();

  try {
    const response = await axiosInstance.post(
      "/tent-house/mappings",
      tentHouseServices,
      {
        method: "POST",
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    if (response.status === 201) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to add the catering services"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const syncTentHouseProviderServices = async (tentHouseServices) => {
  const token = getToken();
  try {
    const response = await axiosInstance.post(
      "/tent-house/sync-mappings",
      { services: tentHouseServices },
      {
        method: "POST",
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to sync tent house services");
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const savePriestEvents = async (updatedData) => {
  const API_URL = "/priest/sync-priest-mappings"; // Adjust the endpoint as needed

  const token = getToken();
  try {
    const response = await axiosInstance.post(API_URL, {
      mappings: updatedData || [],
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to sync proist services");
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const gethelpercategory = async () => {
  try {
    const response = await axiosInstance.get("/helpers/category/services");    
      return response   
  } catch (error) {    
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const gethelperservices = async () => {
  try {
    const response = await axiosInstance.get("/helpers/services");    
      return response   
  } catch (error) {    
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const addprice_to_helper_provider = async () => {
  try {
    const response = await axiosInstance.post("/helpers/provider-prices");    
      return response   
  } catch (error) {    
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getaddedpricevalues = async(provider_id) =>{
  try {
    
    const response = await axiosInstance.get(`/helpers/provider-prices/${provider_id}`)
    return response
  } catch (error) {
    
  }
}